import React from 'react';
import { useSelector } from 'react-redux';
import RepeatableColorPicker from './RepeatableColorPicker.jsx';

function DashboardRepeatableColorPicker(props) {
  const globalPalette = useSelector(state => state.dashboard.theme?.palette?.fills);
  return (
    <RepeatableColorPicker palette={globalPalette} paletteTitle={I18n.t('global_palette')} {...props} />
  )
}

export default DashboardRepeatableColorPicker;